<!--ljm-->
<template>
  <el-dialog :model-value="isShowLinksDialog" :before-close="handleClose" title="填写共享盘链接" width="380px">
    <div class="pq_content">
      <label>链接地址</label>
      <el-input v-model="data.form.remarks_vale" maxlength="200" placeholder="请输入" show-word-limit type="textarea"
        resize="none" :autosize="{ minRows: 5, maxRows: 5 }" />
    </div>
    <template #footer>
      <span class="dialog-footer lc_gxpljbt">
        <el-button @click="comClick('cancel')" size="small">取消</el-button>
        <el-button type="primary" @click="comClick('sure')" size="small">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { defineComponent, onMounted, reactive } from 'vue';
export default defineComponent({
  props: {
    isShowLinksDialog: Boolean,
    linksTitle: String
  },
  emits: ["update:isShowLinksDialog", 'getDragWriteData'],
  setup (props, context) {
    // 生命周期
    onMounted(() => { })
    // 变量
    let data = reactive({
      form: {
        remarks_vale: ''
      },
    })
    const comClick = (type) => {
      if (type == 'sure') {
        context.emit('getDragWriteData', data.form.remarks_vale)
      }
      context.emit("update:isShowLinksDialog", false)
    }
    const handleClose = () => {
      context.emit("update:isShowLinksDialog", false)
    }
    return {
      data,
      props,
      comClick,
      handleClose
    }
  }
})
</script>
<style  scoped lang="scss">
::v-deep(.el-date-editor) {
  width: 100% !important;
}

@import '@/assets/style/lc.scss';
</style>
